export default __webpack_public_path__ + "static/media/cursverti.f6857b82.wav";